import { render, staticRenderFns } from "./epb-badge.component.vue?vue&type=template&id=59bb3e9d&scoped=true"
import script from "./epb-badge.component.vue?vue&type=script&lang=ts"
export * from "./epb-badge.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-badge.component.vue?vue&type=style&index=0&id=59bb3e9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bb3e9d",
  null
  
)

export default component.exports